import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CHECKOUT_URL, CtaButton } from './CtaButton';
import { CORE_PRICE, SALE_PRICE, TOTAL_VALUE } from '../data/content';
import { Reveal } from './Reveal';
export function FinalCtaSection() {
  return <section className="relative w-full overflow-hidden bg-steel-950 px-6 py-16 sm:py-24" aria-labelledby="closing-title" data-id="element-67" data-mp="3qrgf9ndqv8l1">
      <div className="blueprint-grid absolute inset-0" aria-hidden="true" data-id="element-68" data-mp="2y4vqmuonlal6" />
      <Reveal className="relative mx-auto max-w-3xl text-center" data-id="element-69" data-mp="2y2rbfglb0p5l">
        <h2 id="closing-title" className="font-display text-4xl font-bold uppercase leading-[0.98] tracking-tight text-ink-50 sm:text-6xl" data-id="element-70" data-mp="334qfksovbq3l">
          Take control of your
          <span className="block text-ember-400" data-id="element-71" data-mp="3cua0e3w55u13">classroom today</span>
        </h2>

        <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-ink-200 sm:text-lg" data-id="element-72" data-mp="2fee1t16xyz53">
          Don't let another weekend go to waste. Join hundreds of technical educators who are raising
          the bar for industrial training.
        </p>

        <div className="mt-9 border border-white/[0.09] bg-steel-900 p-7 sm:p-9" data-id="element-73" data-mp="2dbgw5hhv2wpj">
          <p className="font-display text-sm font-semibold uppercase tracking-[0.18em] text-ink-500" data-id="element-74" data-mp="28dym1ns3ybfy">
            IIIS 2026 — 6 volumes + 6 bonuses · ${TOTAL_VALUE} total value
          </p>
          <p className="mt-4 flex items-baseline justify-center gap-4" data-id="element-75" data-mp="1ym2k21mwi16g">
            <span className="font-display text-2xl text-ink-500 line-through" data-id="element-76" data-mp="1ul8xpcp3wufo">${CORE_PRICE}</span>
            <span className="font-display text-6xl font-bold text-ember-400 sm:text-7xl" data-id="element-77" data-mp="1pmp914j4p4jm">
              ${SALE_PRICE}
            </span>
          </p>
          <p className="mt-2 text-xs uppercase tracking-[0.14em] text-ink-500" data-id="element-78" data-mp="1knuqm3p2pi01">
            One-time payment · Lifetime access · Digital download
          </p>

          <CtaButton className="mt-8" href={CHECKOUT_URL} label="Yes! I Want To Be An Elite Instructor" data-id="element-79" data-mp="3f1vp2ngpo2zl" />

          <p className="mt-6 flex items-center justify-center gap-2 text-sm text-ink-400" data-id="element-80" data-mp="3a210iqkerphp">
            <ShieldCheckIcon className="h-4 w-4 text-circuit-400" aria-hidden="true" data-id="element-81" data-mp="18clbg1dtfw6h" />
            Backed by the 7-day "First Day of Class" guarantee
          </p>
        </div>
      </Reveal>
    </section>;
}